import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';
import { GlobalVariables } from '../../constants/globals';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';

export const serviceNowAuthTypes = {
    Basic: 'Basic',
    OAuth2: 'OAuth2'
};

@Metamodel.model({
    name: ModelConstants.serviceNowLinkedService,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate, 
            getConnectorV1Name(shellStringResources.ServiceNow_DisplayText)),
        format(shellStringResources.ModelName_LinkedServicesTemplate, 
            getConnectorV1Name(shellStringResources.ServiceNow_DisplayText))
    ]
})
export class ServiceNowLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly ENDPOINT: IAttribute;
    public static readonly USERNAME: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly CLIENT_ID: IAttribute;
    public static readonly CLIENT_SECRET: IAttribute;

    public override  isLegacyConnector = true;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Endpoint,
        association: 'ENDPOINT',
        templatable: GlobalVariables.serviceNowParamedLs
    })
    public endpoint?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UserName,
        association: 'USERNAME',
        templatable: GlobalVariables.serviceNowParamedLs
    })
    public username?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: GlobalVariables.serviceNowParamedLs
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientId,
        association: 'CLIENT_ID',
        templatable: GlobalVariables.serviceNowParamedLs
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_ClientSecret,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'CLIENT_SECRET',
        templatable: GlobalVariables.serviceNowParamedLs
    })
    public clientSecret?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UseEncryptedEndpoints
    })
    public useEncryptedEndpoints?: boolean;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UseHostVerification
    })
    public useHostVerification?: boolean;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UsePeerVerification
    })
    public usePeerVerification?: boolean;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
